export default {
  methods: {
    /**
     * Initializes iframe settings from localStorage
     * Sets this.iframe properties (sidebar, navbar, userDropdown, footer, closeCta)
     * based on the iframe-view value in localStorage
     */
    initializeIframeSettings() {
      const iframeView = localStorage.getItem('iframe-view');
      let tempIframe = null;
      try {
        tempIframe = iframeView && iframeView.length ? JSON.parse(iframeView) : null;
      } catch (e) {
        tempIframe = null;
      }

      this.iframe.sidebar = tempIframe && tempIframe.sidebar === false ? false : true;
      this.iframe.navbar = tempIframe && tempIframe.navbar === false ? false : true;
      this.iframe.userDropdown = tempIframe && tempIframe.userDropdown === false ? false : true;
      this.iframe.footer = tempIframe && tempIframe.footer === false ? false : true;
      this.iframe.closeCta = tempIframe && tempIframe.closeCta === true ? true : false;
    },
    /**
     * Initializes navbar color and menu visibility
     * Sets navbar color based on theme and updates menu visibility
     */
    initializeNavbarSettings() {
      const color =
        this.navbarColor == '#fff' && this.isThemeDark
          ? '#10163a'
          : this.navbarColor;
      this.updateNavbarColor(color);
      this.setNavMenuVisibility(this.$store.state.mainLayoutType);
    },
  },
};

